"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalImportService = void 0;
class InternalImportService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Imports a sponsorship from Molecule/PipeDrive/SESP.
     * @param moleculeCampaignId
     * @param pdDealId
     * @param sespId
     * @param sespPartnershipId
     * @param moleculeOrganizationNames
     * @returns any Successful response
     * @throws ApiError
     */
    internalImportById(moleculeCampaignId, pdDealId, sespId, sespPartnershipId, moleculeOrganizationNames) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/import/internal',
            query: {
                'moleculeCampaignId': moleculeCampaignId,
                'pdDealId': pdDealId,
                'sespId': sespId,
                'sespPartnershipId': sespPartnershipId,
                'moleculeOrganizationNames': moleculeOrganizationNames,
            },
        });
    }
    /**
     * Resets the import util internal agencies cache by reloading it from the crm api
     * @returns any Successful response
     * @throws ApiError
     */
    resetAgenciesCache() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/import/reset-agencie',
        });
    }
    /**
     * Resets the import util internal agents cache by reloading it from the crm api
     * @returns any Successful response
     * @throws ApiError
     */
    resetAgentsCache() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/import/reset-agents',
        });
    }
}
exports.InternalImportService = InternalImportService;
